import * as React from 'react';

import { isCypress } from 'bones/utils/environment';
import { isOnPremise } from 'bones/utils/portal/environment';
import { useAnalyticsConsent } from 'bones/utils/portal/useAnalyticsConsent';
import { usePortalUser } from 'bones/utils/portal/usePortalUser';
import { rollbarAgent } from 'bones/utils/rollbar';

export const setupRollbar = () => {
  if (isCypress() || isOnPremise()) {
    return;
  }

  if (!rollbarAgent.loaded) {
    rollbarAgent.load();
  }
};

export const usePortalRollbar = () => {
  const consent = useAnalyticsConsent();
  const enabled = consent !== null && consent.statistics;

  const { data: user, isLoading } = usePortalUser({
    enabled,
    refetchOnWindowFocus: false,
  });

  React.useEffect(() => {
    if (
      !enabled ||
      isLoading ||
      !user ||
      !user.is_authenticated ||
      user.is_ephemeral
    ) {
      return;
    }
    setupRollbar();
  }, [enabled, isLoading, user]);
};
